module.exports = __webpack_public_path__ + "img/demo-home.4630287a.png";